import axios from 'axios';

// Detect whether running in local development or production
const isLocal = typeof window !== 'undefined' && (
  window.location.hostname === 'localhost' || 
  window.location.hostname === '127.0.0.1'
);

// Local or Live Server API URL based on environment / hostname
export const API_URL = isLocal
  ? 'http://127.0.0.1:8000'
  : (process.env.REACT_APP_API_URL || 'https://www.sawssiddharthvihar.in/admin/public');

const API = axios.create({
  baseURL: `${API_URL}/api`,
  headers: { 'Content-Type': 'application/json' }
});

export const UPLOADS_URL = `${API_URL}/uploads`;

export default API;
